import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { ScrollRestoration } from "react-router-dom";
import TermsOfService from "./TermsOfService";

function TermsOfServiceMain() {
  return (
    <div>
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Nav Bar */}
      <NavBar />
      {/* tos */}
      <TermsOfService />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default TermsOfServiceMain;
